import './AnalyticsTabs.scss';
import { AnalyticsFeatures } from '../AnalyticsFeatures';
import { isShowDataExtractor } from '../dataExtractor/utils/DataExtractorFunctions';
import { analysisDataExtractorStateName, analysisGoodDataStateName, analyticsContactsJourneyStateName, analyticsDashboardStateName, analyticsDataDictionaryStateName, analyticsOverviewStateName, analyticsActiveMessagesStateName, analyticsReportsStateName, } from '..';
const SegmentTracks = {
    dashboard: 'analytics-dashboard-v2-opened',
    activeMessages: 'active-messages-opened',
    overview: 'analytics-dashboard-opened',
    reports: 'analytics-custom-reports-opened',
    contactsJourney: 'analytics-journey-opened',
    dataDictionary: 'analytics-datadictionary-opened',
    dataExtractor: 'analytics-dataExtractor-opened',
};
export class AnalyticsTabsController {
    static $inject = ['$state', 'SegmentService', 'application', '$scope'];
    constructor($state, SegmentService, application, $scope) {
        'ngInject';
        this.$state = $state;
        this.SegmentService = SegmentService;
        this.application = application;
        this.$scope = $scope;
        this.isDisplayingOverviewTab = false;
        this.isDisplayingActiveMessagesTab = false;
        this.isShowingDataDictionary = false;
        this.isShowingDataExtractor = false;
        this.isShowingGoodData = false;
        this.tabData = {
            dashboard: { active: false, route: analyticsDashboardStateName },
            activeMessages: { active: false, route: analyticsActiveMessagesStateName },
            overview: { active: false, route: analyticsOverviewStateName },
            reports: { active: false, route: analyticsReportsStateName },
            contactsJourney: { active: false, route: analyticsContactsJourneyStateName },
            dataDictionary: { active: false, route: analyticsDataDictionaryStateName },
            dataExtractor: { active: false, route: analysisDataExtractorStateName },
            goodData: { active: false, route: analysisGoodDataStateName },
        };
        this.$onInit = async () => {
            await this.checkFeatures();
            this.initilizeTabs();
            this.handlePosition();
            // store bound handler to allow proper removal
            this._boundHandlePosition = () => this.handlePosition();
            window.addEventListener('scroll', this._boundHandlePosition);
        };
        this.initilizeTabs = () => {
            let currentPage = this.$state.current.url.toString().replace('/', '');
            if (currentPage.includes('report')) {
                currentPage = this.handleSingleReportRedirect(currentPage);
            }
            else if (currentPage.includes('dataDictionary')) {
                this.handleDataDictionaryQueryParams();
            }
            this.tabData[currentPage].active = true;
        };
        this.checkFeatures = async () => {
            this.isDisplayingOverviewTab = await AnalyticsFeatures.isDisplayingAnalyticsOverviewTab();
            this.isDisplayingActiveMessagesTab = await AnalyticsFeatures.isDisplayingAnalyticsActiveMessagesTab();
            this.isShowingDataDictionary = await AnalyticsFeatures.isShowingDataDictionary();
            this.isShowingDataExtractor = await isShowDataExtractor();
            this.isShowingGoodData = await AnalyticsFeatures.isShowingGoodData();
        };
        this.handlePosition = (shouldTriggerReposition = true) => {
            const mainBarBottom = document.querySelector('main-navbar')?.getBoundingClientRect()?.bottom;
            if (mainBarBottom) {
                const bdsTabs = document.querySelector('bds-tabs');
                if (bdsTabs && bdsTabs.style) {
                    bdsTabs.style.top = `${mainBarBottom}px`;
                }
                if (shouldTriggerReposition) {
                    setTimeout(() => this.handlePosition(false), 500);
                }
            }
        };
        // Ensure $onDestroy() is called when scope is destroyed
        this.$scope.$on('$destroy', () => {
            if (typeof this.$onDestroy === 'function') {
                this.$onDestroy();
            }
        });
    }
    $onDestroy() {
        if (this._boundHandlePosition) {
            window.removeEventListener('scroll', this._boundHandlePosition);
            this._boundHandlePosition = null;
        }
    }
    onClickTab(tabName) {
        this.enableTabController(tabName);
        this.trackOpenTab(tabName);
        this.$state.go(this.tabData[tabName].route);
    }
    handleDataDictionaryQueryParams() {
        const uri = window.location.href;
        if (uri.includes('?path')) {
            const params = uri.split('?')[1];
            this.queryParams = params.split('=')[1];
        }
    }
    handleSingleReportRedirect(currentPage) {
        currentPage = 'reports';
        this.$state.go(this.tabData[currentPage].route);
        return currentPage;
    }
    enableTabController(tabName) {
        this.tabData[tabName].active = true;
        this.handlePosition();
    }
    trackOpenTab(tabName) {
        this.SegmentService.createApplicationTrack({
            trackEvent: SegmentTracks[tabName],
            application: this.application,
        });
    }
}
AnalyticsTabsController.$inject = ['$state', 'SegmentService', 'application', '$scope'];
